import React, {useContext, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import TourPoint from "/src/pages/TourPoint";
import {ToursContext} from "@/ToursContext";
import TourPointListItem from "@/components/TourPointListItem";
import {useOverlay} from "@/OverlayContext";
import {showMultiLingualText} from "@/utils/LanguageUtils";
import Points from "/src/pages/Points"; // Import the Points component

export default function Point() {
    const params = useParams();
    let { point, page } = params;
    console.log(point, page);
    const navigate = useNavigate();

    const [tourPoint, setTourPoint] = useState(null)
    const [tours, setTours] = useState(null)
    const [loading, setLoading] = useState(true)

    const { accountTours, setAccountTours, activeTour, setActiveTour } = useContext(ToursContext);
    const { setOverlay, setOverlayIsVisible } = useOverlay();

    // get a list of all tourPoints for this point
    useEffect(() => {
        loadData()
    }, [point, activeTour]);

    // Effect to open the overlay when tourPoint is loaded
    useEffect(() => {
        if (tourPoint) {
            setOverlay(
                <TourPoint 
                    tourPoint={tourPoint} 
                    onContentLoaded={() => {
                        console.log('Content loaded callback triggered');
                        setOverlayIsVisible(true);
                    }} 
                />,
                showMultiLingualText(tourPoint.title, '', true), // Title
                null, // Subtitle
                tourPoint.image, // Image
                () => {
                    // This function will be called when the overlay is closed
                    console.log('Overlay closed callback triggered');
                    
                    // Update URL to points page without navigating
                    const pointsUrl = `/${params.language ? `${params.language}/` : ''}points`;
                    window.history.replaceState(null, '', pointsUrl);
                }
            );
        }
    }, [tourPoint]);

    const loadData = async (code=null) => {
        setLoading(true);
        console.log("load details for point " + point);

        // get point
        let headers = {
            ...(activeTour && {
                "X-Tour-Id": activeTour
            }),
        }

        let endpoint = "point"
        axiosInstance.get(`${process.env.CLIENT_API_URL}/client/${endpoint}/${point}`, {headers: headers}) // get points
            .then((response) => {
                if (activeTour) {
                    // sometimes the point from params are not hashed (old QR codes). if so, we neet to redirect to the same point, but with hashed Ids.
                    if (point !== response.data.id) {
                        console.log("redirect to", `/${params.language ? `${params.language}/` : ''}point/${response.data.id}`);
                        return navigate(`/${params.language ? `${params.language}/` : ''}point/${response.data.id}`, {replace: true});
                    }

                    if (response.data) {
                        // get the tourid from the tour
                        const tourPointData = Object.values(response.data.tour_points).find(tp => tp.tour.id === activeTour);
                        if (tourPointData) {
                            setTourPoint(tourPointData);
                        } else {
                            // point was found, but not for this tour
                            navigate(`/${params.language ? `${params.language}/` : ''}points`, {replace: true});
                        }
                    }
                } else {
                    console.log("no tour active, get point details and show tours overview. (this is replaced the tours endpoint).");
                    console.log(response.data);

                    if (response.data.tour_points?.length === 1) {
                        const tourPointData = response.data.tour_points[0];
                        setActiveTour(tourPointData.tour.id);
                        setTourPoint(tourPointData);
                    } else {
                        setTours(response.data.tour_points);
                    }
                }
            }).catch(() => {
                console.log("point not found");
                if (activeTour) {
                    navigate(`/${params.language ? `${params.language}/` : ''}points`);
                } else {
                    navigate(`/${params.language ? `${params.language}/` : ''}not-found`);
                }
            }).finally(() => {
                setLoading(false);
            });
    }

    return (
        <div>
            {loading && (
                <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
                </div>
            )}
            
            {/* Only render the tour list if we have multiple tours and no specific tour is active */}
            {!loading && !tourPoint && tours && (
                <>
                    {Object.entries(tours).map(([index, tourPoint]) => (
                        <TourPointListItem key={index} tourPoint={tourPoint}/>
                    ))}
                </>
            )}
        </div>
    );
}